/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/
import React, { useEffect, useState } from 'react';

// reactstrap components
import { Card, CardBody, CardTitle, Row, Col, Spinner } from "reactstrap";
// core components
import { studentBoundList, reportStudentCollections } from "../../../../network/ApiAxios.js";
import secureLocalStorage from "react-secure-storage";

const KPIStudents = (props) => {
  const [isLoading, setisLoading] = useState(false)
  const [students, setStudents] = useState([])
  const [bound, setBound] = useState([])
  const [collections, setCollections] = useState([])
  const user = JSON.parse(secureLocalStorage.getItem("user"));
  const app = JSON.parse(secureLocalStorage.getItem("app"));

  useEffect(() => {
    const runCountStudents = async () => {
      setisLoading(true);

      let params = {
        filter: { account: user.account, active: true },
        constraint: { app: app._id, installation: { active: true } }
      }

      const response = await studentBoundList(params);
      const { data } = response;

      if (data.success) {
        let countStudents = data.students.length
        let countBound = 0
        let studentIds = []
        data.students.map(student=>{
          studentIds.push(student._id.toString())
          if(student.isBound){
            countBound+=1
          }
        })
        setStudents(countStudents)
        setBound(countBound)

        let params = {
          filter: { studendIds: studentIds },
          constraint: { app: app._id }
        }
        const response = await reportStudentCollections(params);

        if (response.data.success) {
          setCollections(response.data.report)
        }        
      }

      setisLoading(false);      
    }

    runCountStudents();

  }, []);

  return (
    <>
      <Card className="card-stats mb-4 mb-xl-0">
        {
          isLoading ?
            <div className="text-center p-5">
              <Spinner size="lg" />
            </div>
            :
            <CardBody>
              <Row>
                <div className="col">
                  <CardTitle
                    tag="h5"
                    className="text-uppercase text-muted mb-0"
                  >
                    Students
                  </CardTitle>
                  <span className="h2 font-weight-bold mb-0">{students}</span>
                </div>
                <Col className="col-auto">
                  <div className="icon icon-shape bg-yellow text-white rounded-circle shadow">
                    <i className="fas fa-users" />
                  </div>
                </Col>
              </Row>
              <p className="mt-3 mb-0 text-muted text-sm">
                <span className="text-success mr-2">
                  {bound}
                </span>{" "}
                <span className="text-nowrap">With Licenses</span>
              </p>
              <p className="mt-3 mb-0 text-muted text-sm">
                <span className="text-success mr-2">
                  {collections.withCollections}
                </span>{" "}
                <span className="text-nowrap">With Collections</span>
              </p>
              <p className="mt-3 mb-0 text-muted text-sm">
                <span className="text-success mr-2">
                  {collections.totalCollections}
                </span>{" "}
                <span className="text-nowrap">Total Collections</span>
              </p>
            </CardBody>
        }
      </Card>
    </>
  );
};

export default KPIStudents;
